import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LogIn } from 'lucide-react';

const Login = () => {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [epost, setEpost] = useState('');
  const [passord, setPassord] = useState('');
  const [totp, setTotp] = useState('');
  const [krevTotp, setKrevTotp] = useState(false);
  const [feil, setFeil] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user) nav('/'); }, [user, nav]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setFeil(''); setBusy(true);
    try { await login(epost, passord, totp); nav('/'); }
    catch (err) {
      const data = err.response?.data;
      if (data?.code === 'TOTP_REQUIRED') {
        setKrevTotp(true);
        setFeil('Skriv inn 6-sifret kode fra autentiseringsappen.');
      } else {
        setFeil(data?.error || 'Innlogging feilet.');
      }
    }
    finally { setBusy(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  background: 'var(--theme-bg-primary)', padding: 16 }}>
      <div className="card" style={{ width: '100%', maxWidth: 380, padding: 28 }}>
        <div className="flex items-center justify-center" style={{ marginBottom: 20 }}>
          <img src="/logo.png" alt="REGNINO" style={{ height: 48, width: 'auto', maxWidth: '100%', objectFit: 'contain' }} />
        </div>
        <form onSubmit={onSubmit}>
          <label>E-post</label>
          <input type="email" value={epost} onChange={(e) => setEpost(e.target.value)}
                 autoFocus required style={{ marginBottom: 10 }} />
          <label>Passord</label>
          <input type="password" value={passord} onChange={(e) => setPassord(e.target.value)}
                 required style={{ marginBottom: 10 }} />
          {krevTotp && (
            <>
              <label>2FA-kode</label>
              <input value={totp} onChange={(e) => setTotp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                     placeholder="123456" inputMode="numeric" autoFocus required
                     style={{ marginBottom: 10, letterSpacing: 4, fontSize: 16, textAlign: 'center' }} />
            </>
          )}
          {feil && (
            <div className="badge badge-danger" style={{ width: '100%', justifyContent: 'center', padding: 8, marginBottom: 12 }}>
              {feil}
            </div>
          )}
          <button type="submit" disabled={busy} className="btn-primary"
                  style={{ width: '100%', height: 36, justifyContent: 'center' }}>
            <LogIn size={14} /> {busy ? 'Logger inn…' : 'Logg inn'}
          </button>
        </form>
        <div style={{ textAlign: 'center', marginTop: 14, fontSize: 12 }}>
          <Link to="/glemt-passord">Glemt passord?</Link>
        </div>
        <div style={{ textAlign: 'center', marginTop: 6, fontSize: 12 }}>
          Ny her? <Link to="/registrer">Opprett ny konto</Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
